import images from '../../../assets/images';
import './CommonChatPersonCard.scss';
import { FC } from 'react';
import { chatListType, defaultUserType, searchUserType } from '../CommonChats';

interface propsStyle{
    groupChatData?: chatListType,
    chatData?: defaultUserType,
    searchChatData?: searchUserType,
    onClick: () => void,
    selectedChat?: defaultUserType | undefined,
    selectedGroupChat?: chatListType | undefined,
    selectedSearchChat?: searchUserType | undefined,
    type : string
}
const CommonChatPersonCard:FC<propsStyle> = ({groupChatData, searchChatData, chatData, selectedSearchChat,selectedGroupChat, selectedChat, onClick, type}) => {
    const {GroupChatIcon, UserActiveIcon, User} = images;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;

  return (
    type === "search" ?
    (
        <div 
        className={'CommonChatPersonCardContainer'}
        style={{
            backgroundColor: searchChatData?.uId === selectedSearchChat?.uId ? '#EDFAFF':'white',
        }}
        onClick={onClick}
    >
        <div  className='GroupChatIconContainer'>
            <img src={(searchChatData?.uRole === 'TEACHER' && searchChatData?.teachersByUId?.nodes?.[0]?.tAvatarUrl) ? (baseUrl+searchChatData?.teachersByUId?.nodes?.[0]?.tAvatarUrl):(searchChatData?.uRole === 'STUDENT' && searchChatData?.studentsByUId?.nodes?.[0]?.sAvatarUrl) ? (baseUrl+searchChatData?.studentsByUId?.nodes?.[0]?.sAvatarUrl): User} alt='group'  className='GroupChatIconStyle'/>
        </div>
        <label 
            className={'oneToOneLableStyle'}
        >
            {`${searchChatData?.uFullName}`}
        </label>
        {/* {
            <img src={UserActiveIcon} alt={`active`} className='userActiveStyle'/>
        } */}
    </div>
    ):type === "defaultUser" ? (
        <div 
        className={'CommonChatPersonCardContainer'}
        style={{
            backgroundColor: chatData?.chatId === selectedChat?.chatId ? '#EDFAFF':'white',
        }}
        onClick={onClick}
    >
        <div  className='GroupChatIconContainer'>
            <img
                // src={
                //     (chatData?.user1Id === profile?.getCurrentUser?.nodes?.[0]?.uId)
                //         ? (chatData?.userByUser2Id?.uRole === "TEACHER" && chatData?.userByUser2Id?.teachersByUId?.nodes?.[0]?.tAvatarUrl)
                //             ? (baseUrl+chatData?.userByUser2Id?.teachersByUId?.nodes?.[0]?.tAvatarUrl)
                //             : (chatData?.userByUser2Id?.uRole === "STUDENT" && chatData?.userByUser2Id?.studentsByUId?.nodes?.[0]?.sAvatarUrl)
                //                 ? (baseUrl+chatData?.userByUser2Id?.studentsByUId?.nodes?.[0]?.sAvatarUrl)
                //                 : (chatData?.user2Id === profile?.getCurrentUser?.nodes?.[0]?.uId)
                //                     ? (chatData?.userByUser1Id?.uRole === "TEACHER" && chatData?.userByUser1Id?.teachersByUId?.nodes?.[0]?.tAvatarUrl)
                //                         ? (baseUrl+chatData?.userByUser1Id?.teachersByUId?.nodes?.[0]?.tAvatarUrl)
                //                         : (chatData?.userByUser1Id?.uRole === "STUDENT" && chatData?.userByUser1Id?.studentsByUId?.nodes?.[0]?.sAvatarUrl)
                //                             ? (baseUrl+chatData?.userByUser1Id?.studentsByUId?.nodes?.[0]?.sAvatarUrl)
                //                             : User
                //                     : User
                //         : User
                // }
                src={((chatData?.from?.uRole === "TEACHER") && chatData?.to?.teachersByUId?.nodes?.[0]?.tAvatarUrl) 
                        ? (baseUrl + chatData?.to?.teachersByUId?.nodes?.[0]?.tAvatarUrl)
                        :((chatData?.from?.uRole === "STUDENT") && chatData?.to?.studentsByUId?.nodes?.[0]?.sAvatarUrl)
                          ? (baseUrl + chatData?.to?.studentsByUId?.nodes?.[0]?.sAvatarUrl) : User}
                alt='group' className='GroupChatIconStyle' />
        </div>
        <label 
            className={'oneToOneLableStyle'}
        >
           {chatData?.to?.uFullName}
        </label>
        {
            chatData?.to?.uChatActive 
            && <img src={ UserActiveIcon } alt={`active`} className='userActiveStyle'/>
        }
        {(chatData?.unReadMessagesCount !== undefined && chatData?.unReadMessagesCount > 0) && (<div  className={chatData?.unReadMessagesCount > 0 ?'chatUnreadCountStyle':'chatUnreadCountStyleDisable'}>{chatData?.unReadMessagesCount}</div>)}
    </div>
    ):(
    <div 
        className={'CommonChatPersonCardContainer'}
        style={{
            backgroundColor: groupChatData?.chatId === selectedGroupChat?.chatId ? '#4BCD5C' : 'var(--color-deepskyblue)',
        }}
        onClick={onClick}
    >
        <div  className='GroupChatIconContainer'>
            <img src={GroupChatIcon} alt='group'  className='GroupChatIconStyle'/>
        </div>
        <label 
            className={'groupLableStyle'}
        >
            {`${groupChatData?.chatroomName}`}
        </label>
        {/* {
            chatData?.chatType === 'OneToOne' ?
            <img src={UserActiveIcon} alt={`active`} className='userActiveStyle'/>
            : <></>
        } */}
    </div>
    )
  )
}

export default CommonChatPersonCard;
